import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';
import { initAnalytics, initSentry } from './utils/observability';

// Error tracking and privacy-friendly analytics: both off unless REACT_APP_SENTRY_DSN / REACT_APP_ANALYTICS are set
initSentry();
initAnalytics();

// Define custom theme
const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'var(--app-bg, #06070b)',
        color: 'var(--app-text, #f4f6fb)',
      },
    },
  },
  colors: {
    brand: {
      50: '#f0f8ff',
      100: '#d1e6ff',
      200: '#a8d0ff',
      300: '#7fb9ff',
      400: '#56a3ff',
      500: '#2d8cff', // Primary brand color
      600: '#1971f1',
      700: '#0d57e0',
      800: '#083cc5',
      900: '#062d9e',
    },
  },
  fonts: {
    heading: 'Inter, sans-serif',
    body: 'Inter, sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </Router>
    </ChakraProvider>
  </React.StrictMode>
); 